<template>
    <button class="ui icon blue button back-to-top"
        :data-tooltip="$t('ui.toolbox.back_to_top_button.back_to_top')">
        <i class="long arrow up icon"></i>
    </button>
</template>

<script>
export default {
    name: "ToolBackToTopButtonMain",
    data() {
        return {
        }
    },
    mounted() {
        $('.back-to-top').css('opacity', 0)
        $('.back-to-top').on('click', (event) => {
            event.preventDefault()
            $('html, body').animate({
                scrollTop: 0
            }, 300)
        })

        $(window).scroll(() => {
            var y = $(this).scrollTop()
            var opacity = $('.back-to-top').css('opacity')

            if (y > 400 && opacity == '0') {
                $('.back-to-top').animate({
                    'opacity': '1'
                }, 200)

            } else if (y < 400 && opacity == '1') {
                $('.back-to-top').animate({
                    'opacity': '0'
                }, 200)
            }
        })
    }
}
</script>

<style lang="scss">
    @import "./main.css";
</style>
